export { default as ProductTypeEdit } from './ProductTypeEdit';
export { default as ProductTypeList } from './ProductTypeList';